// All user feature previews are prefixed with "user-"
export enum UserFeaturePreviews {
  SUGGESTED_FRIENDS = 'user-suggested-friends',
  FRIENDS_ACTIVITIES = 'user-friends-upcoming-activities',
  YEARLY_RECAP = 'user-yearly-recap',
  PAYMENT_ELEMENT = 'user-stripe-payment-element',
}
